import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";
import invariant from "ts-invariant";

import { getFragmentData } from "@/generated/graphql";
import { FeelingEnum, GetUserFeelingsDocument, UserFeelingFragmentDoc } from "@/generated/graphql/graphql";

export function useUserFeeling(feelingKey: FeelingEnum) {
  const { data } = useQuery(GetUserFeelingsDocument, { fetchPolicy: "cache-only" });
  return useMemo(() => {
    const userFeelings = getFragmentData(UserFeelingFragmentDoc, data?.userFeelings || []);
    const userFeeling = userFeelings.find((feeling) => feeling.feelingKey === feelingKey);
    invariant(userFeeling, `Feeling ${feelingKey} not found`);
    return userFeeling;
  }, [data?.userFeelings, feelingKey]);
}
